/* eslint-disable no-return-await */
import Util from '@/assets/libs/util'
import requestModule from '@/assets/libs/requestModule.js'

const GET_WEIGHT_PRODUCTS_ENDPOINT = 'menu/getWeightProducts'

const loadData = async function (config) {
    let weighedProds = []
    let weighedProdsRaw = await getWeighedProds(config)
    weighedProds = extractProdsFromGroups(weighedProdsRaw)
    return weighedProds
}

const getWeighedProds = async function (config) {
    const payload = Util.getGeneralInfo()
    return await requestModule.postRequest(GET_WEIGHT_PRODUCTS_ENDPOINT, payload).then(response => response.data || [])
}

const extractProdsFromGroups = function (weighedProdsRaw) {
    let prods = []
    try {
        let hasAnyGroup = weighedProdsRaw && weighedProdsRaw.groups && weighedProdsRaw.groups.length > 0
        if (hasAnyGroup) {
            weighedProdsRaw.groups.forEach(group => {
                let groupHasProducts = group.products && group.products.length > 0
                if (groupHasProducts) {
                    group.products.forEach(product => {
                        prods.push(product)
                    })
                }
            })
        }
    } catch (error) {
        console.log('Nao foi possivel extrair os produtos pesaveis a partir da resposta recebida da odhen interface')
        prods = []
    }
    return prods
}

export default {
    loadData
}



// WEBPACK FOOTER //
// ./src/components/BalancaModeConfig/BalancaMode.js